export const formatPrice = (price: number | undefined): string => {
  if (typeof price !== 'number') return 'Price not available';
  return price === 0 ? 'Free' : `$${price.toFixed(2)}`;
};